// src/pages/ReviewsPage.jsx
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import PdfDocumentSection from "../components/PdfDocumentSection";
import usePdfConfig from "../hooks/usePdfConfig";
import { getPdfDocumentsForSection } from "../utils/pdfDocuments";
import "./ReviewsPage.css";

const DEFAULT_REVIEWS = [
  {
    img: "/review1.jpg",
    name: "Rohit Paul & Shveta",
    city: "Gurugram",
    quote:
      "Hats off to the entire team. They finished the project ahead of time.",
    video: "#",
  },
  {
    img: "/review2.jpg",
    name: "Swati & Gaurav",
    city: "Bangalore",
    quote:
      "Our experience was great, thanks to the professional project managers.",
    video: "#",
  },
  {
    img: "/review3.jpg",
    name: "Puja Bhatia",
    city: "Gurugram",
    quote: "We reached out and they designed the home we really wanted.",
    video: "#",
  },
  // add more here if you have them…
];

export default function ReviewsPage({ reviews }) {
  const { pdfConfig } = usePdfConfig();
  const data =
    Array.isArray(reviews) && reviews.length ? reviews : DEFAULT_REVIEWS;
  const reviewPdfDocuments = useMemo(
    () => getPdfDocumentsForSection(pdfConfig?.documents, "reviews"),
    [pdfConfig?.documents]
  );

  return (
    <main className="reviews-page">
      <section className="reviews-page-inner">
        <header className="reviews-page-header">
          <div>
            <h1>Customer Reviews</h1>
            <p>
              Hear what our happy customers have to say about their interior
              experience with us.
            </p>
          </div>

          <Link to="/" className="reviews-back">
            ← Back to Home
          </Link>
        </header>

        <div className="reviews-page-grid">
          {data.map((r, i) => (
            <article key={i} className="rp-card">
              <div className="rp-media">
                <img src={r.image || r.img || "/placeholder.jpg"} alt={r.name} />

                <a
                  href={r.videolink || r.video || "#"}
                  className="rp-play"
                  aria-label="Play video"
                >
                  ▶
                </a>

                <div className="rp-overlay">
                  <p className="rp-name">{r.name}</p>
                  <p className="rp-city">{r.city}</p>
                </div>
              </div>

              <p className="rp-quote">{r.description || r.quote}</p>
            </article>
          ))}
        </div>

        {reviewPdfDocuments.length > 0 && (
          <section className="reviews-page-docs">
            <PdfDocumentSection
              documents={reviewPdfDocuments}
              title="Documents"
              subtitle="Click any card to open and preview the PDF."
              mode="section"
              styleConfig={pdfConfig?.styleConfig}
            />
          </section>
        )}
      </section>
    </main>
  );
}
